import { formatter, request } from '@/utils/request';

export namespace SalesContract {
  export const Path = {
    Query: '/expenseapi/contract/query', //查询合同页面数据
    Export: '/expenseapi/contract/export', //导出Excel
    Get: '/expenseapi/contract/get',
    Post: '/expenseapi/contract/post',
    Delete: '/expenseapi/contract/delete',
    Deactive: '/expenseapi/contract/deactive',
    Confirm: '/expenseapi/contract/confirm',
    DownLoad: '/expenseapi/contract/downLoadExcel',
    SalesContractImportValidate: '/expenseapi/contract/salesContractImportValidate',
    SalesContractImport: '/expenseapi/contract/salesContractImport',
    GetSalesContracts: '/expenseapi/contract/getSalesContracts',
  };

  export async function salesContractImport(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.SalesContractImport, formatter(options));
  }

  export async function getSalesContracts(body: API.SalesContractSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.GetSalesContracts, formatter(options));
  }

  export async function salesContractImportValidate(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ImportResult>>(
      Path.SalesContractImportValidate,
      formatter(options),
    );
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.QueryForSalesContractData>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.QueryForSalesContractData>>(Path.Export, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.SalesContract>>(Path.Get, formatter(options));
  }

  export async function post(body: {
    salesContract: API.SalesContract;
    salesContractTermsList: API.SalesContractTermsVo[];
  }) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.Post, formatter(options));
  }

  export async function del(id: number) {
    const options = {
      method: 'POST',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export function deactive(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Deactive, formatter(options));
  }

  export function confirm(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Confirm, formatter(options));
  }
}
